(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cc-footer"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var mq = window.matchMedia('(max-width: 749px)');
    function sync() {
      document.querySelectorAll('.cc-footer__col').forEach(function (d) {
        if (mq.matches) d.removeAttribute('open');
        else d.setAttribute('open', '');
      });
    }
    sync();
    mq.addEventListener('change', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-hero-carousel')) {
    class CcHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.cc-hero__track');
        this.slides = [...this.querySelectorAll('.cc-hero__slide')];
        this.dots = [...this.querySelectorAll('.cc-hero__dot')];
        this.index = 0;
        if (this.slides.length < 2) return;
        this.querySelectorAll('.cc-hero__arrow').forEach((b) =>
          b.addEventListener('click', () => this.go(this.index + parseInt(b.dataset.dir, 10), true))
        );
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(parseInt(d.dataset.index, 10), true)));
        this.track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
        });
        let t;
        this.track.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const i = Math.round(this.track.scrollLeft / this.track.clientWidth);
            if (i !== this.index) this.setActive(i);
          }, 80);
        }, { passive: true });
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (this.dataset.autoplay === 'true' && !reduce) {
          const speed = parseInt(this.dataset.speed, 10) || 6000;
          const tick = () => (this.timer = setInterval(() => this.go(this.index + 1), speed));
          tick();
          this.addEventListener('pointerenter', () => clearInterval(this.timer));
          this.addEventListener('pointerleave', () => { clearInterval(this.timer); tick(); });
          this.addEventListener('focusin', () => clearInterval(this.timer));
        }
      }

      go(i, user) {
        const n = this.slides.length;
        const next = ((i % n) + n) % n;
        this.track.scrollTo({ left: next * this.track.clientWidth, behavior: 'smooth' });
        this.setActive(next);
        if (user) clearInterval(this.timer);
      }

      setActive(i) {
        this.index = i;
        this.dots.forEach((d, k) => {
          d.classList.toggle('is-active', k === i);
          d.setAttribute('aria-selected', k === i ? 'true' : 'false');
        });
        this.slides.forEach((s, k) => {
          s.querySelectorAll('a').forEach((a) => (k === i ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
      }
    }
    customElements.define('cc-hero-carousel', CcHeroCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cc-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cc-recently-viewed')) {
    const KEY = 'cc_recently_viewed';

    const money = (cents, format) => {
      const value = (cents / 100).toFixed(2);
      const [whole, dec] = value.split('.');
      const withCommas = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      if (!format) return '$' + withCommas + '.' + dec;
      return format
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withCommas.replace(/,/g, '.') + ',' + dec)
        .replace(/\{\{\s*amount\s*\}\}/, withCommas + '.' + dec);
    };

    class CcRecentlyViewed extends HTMLElement {
      connectedCallback() {
        const current = this.dataset.current;
        const limit = parseInt(this.dataset.limit, 10) || 5;
        let list = [];
        try {
          list = JSON.parse(localStorage.getItem(KEY) || '[]');
        } catch (e) {
          list = [];
        }
        const others = list.filter((h) => h && h !== current).slice(0, limit);
        if (current) {
          const next = [current, ...list.filter((h) => h !== current)].slice(0, 12);
          try {
            localStorage.setItem(KEY, JSON.stringify(next));
          } catch (e) {}
        }
        if (others.length) this.render(others);
      }

      async render(handles) {
        const root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        const results = await Promise.all(
          handles.map((h) =>
            fetch(root + 'products/' + encodeURIComponent(h) + '.js')
              .then((r) => (r.ok ? r.json() : null))
              .catch(() => null)
          )
        );
        const grid = this.querySelector('.cc-rv__grid');
        const items = results.filter(Boolean);
        if (!items.length) return;
        grid.innerHTML = '';
        items.forEach((p) => {
          const li = document.createElement('li');
          li.className = 'cc-rv__item';
          const img = p.featured_image ? p.featured_image + (p.featured_image.includes('?') ? '&' : '?') + 'width=480' : '';
          const compare = p.compare_at_price && p.compare_at_price > p.price ? '<s>' + money(p.compare_at_price, this.dataset.moneyFormat) + '</s>' : '';
          li.innerHTML =
            '<a class="cc-rv__card" href="' + root + 'products/' + p.handle + '">' +
            '<span class="cc-rv__media">' + (img ? '<img loading="lazy" width="480" height="480" alt="" src="' + img + '">' : '') + '</span>' +
            '<span class="cc-rv__title"></span>' +
            '<span class="cc-rv__price">' + money(p.price, this.dataset.moneyFormat) + ' ' + compare + '</span></a>';
          li.querySelector('.cc-rv__title').textContent = p.title;
          li.querySelector('img') && (li.querySelector('img').alt = p.title);
          grid.appendChild(li);
        });
        this.closest('.cc-rv-wrap').hidden = false;
      }
    }
    customElements.define('cc-recently-viewed', CcRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
